import { FC } from 'react';
import { Box, Typography, Button, Link, IconButton } from '@mui/material';
import { Colors } from '../../styles/theme';
import { MENU_ITEMS } from '../../const/menuItems';
import { APP_CONFIG } from '../../const/APP_CONFIG';
import { useNavigate } from 'react-router-dom';
import Logo from '../Logo';
import SmoothLink from '../SmoothLink';

const SNS_ICONS = [
  {
    label: 'Thread',
    src: '/images/thread.png',
    alt: 'thread',
    link: APP_CONFIG.social.threads,
  },
  {
    label: 'Instagram',
    src: '/images/instagram.png',
    alt: 'instagram',
    link: APP_CONFIG.social.instagram,
  },
  {
    label: 'TikTok',
    src: '/images/tiktok.png',
    alt: 'tiktok',
    link: APP_CONFIG.social.tiktok,
  },
];

const FooterSection: FC = () => {
  const navigate = useNavigate(); // useNavigate 사용

  return (
    <Box
      sx={{
        backgroundColor: '#FAFAFA',
        color: Colors.black,
        padding: {
          xs: '48px 32px 100px',
          sm: '70px 40px',
          md: '80px',
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          width: '100%',
          maxWidth: '1440px',
          gap: '32px',
          alignItems: { xs: 'center', sm: 'flex-start', md: 'flex-start' },
          textAlign: { xs: 'center', md: 'left' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'flex-start', md: 'flex-start' },
            width: {
              xs: '100%',
              sm: 'auto',
            },
            justifyContent: 'space-between',
            minWidth: { md: '150px' },
          }}
        >
          <Box sx={{ marginBottom: { xs: '24px', sm: '48px' } }}>
            <Logo width={120} height={32} />
          </Box>
          {MENU_ITEMS.map((item) => (
            <SmoothLink
              key={item.label}
              to={item.path}
              style={{
                marginBottom: '8px',
                cursor: 'pointer',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: '16px',
                lineHeight: '130%',
                letterSpacing: '-2%',
                textDecoration: 'none',
                color: Colors.black,
              }}
                          >
              <Typography variant="body1">{item.label}</Typography>
            </SmoothLink>
          ))}
        </Box>

        {/* Right Column: Slogan and Button */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'flex-start', md: 'flex-start' },
            width: {
              xs: '100%',
              sm: '430px',
              md: '856px',
            },
          }}
        >
          <Typography
            variant="h4"
            component="p"
            sx={{
              fontWeight: 400,
              letterSpacing: '-0.6px',
              marginBottom: {
                xs: '24px',
                sm: '53px',
                md: '40px',
              },
              fontSize: {
                xs: '20px',
                sm: '34px',
                md: '40px',
              },
              display: 'inline-block',
            }}
            align={'left'}
          >
            Let AI do the heavy lifting. <br />
            you focus on repairs.
          </Typography>
          <SmoothLink
            to="/#download"
            style={{ textDecoration: 'none' }}
                      >
            <Button
              variant="contained"
              sx={{
                backgroundColor: Colors.blue,
                color: 'white',
                padding: { xs: '8px 24px', sm: '16px 32px' },
                fontWeight: 700,
                fontSize: {
                  xs: '14px',
                  sm: '16px',
                },
                borderRadius: '8px',
                textTransform: 'none',
              }}
            >
              Get It Now
            </Button>
          </SmoothLink>
        </Box>
      </Box>
      <Box
        sx={{
          color: Colors.blackAlpha50,
          paddingTop: {
            xs: '60px',
            sm: '60px',
            md: '120px',
          },
          width: '100%',
          maxWidth: '1440px',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '8px',
          fontSize: {
            xs: '14px',
            sm: '16px',
          },
        }}
      >
        <Typography
          variant="body2"
          sx={{
            marginBottom: { xs: '4px', sm: 0 },
            width: {
              xs: '100%',
              sm: 'auto',
            },
          }}
          align={'left'}
        >
          {`Copyright © ${APP_CONFIG.name} 2025`}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: '24px',
            marginBottom: { xs: '4px', sm: 0 },
            width: {
              xs: '100%',
              sm: 'auto',
            },
          }}
        >
          <Link
            onClick={() => {
              navigate('/privacy');
            }}
            color="inherit"
            underline="hover"
          >
            Privacy Policy
          </Link>
          <Link
            onClick={() => {
              navigate('/term');
            }}
            color="inherit"
            underline="hover"
          >
            Terms of Service
          </Link>
        </Box>
        {/* <Box
          sx={{
            display: 'flex',
            gap: '15px',
            width: {
              xs: '100%',
              sm: 'auto',
            },
          }}
        >
          {SNS_ICONS.map((icon) => (
            <IconButton
              key={icon.label}
              aria-label={icon.label}
              sx={{
                width: '30px',
                height: '30px',
              }}
              component="a"
              href={icon.link}
              target="_blank"
              rel="noopener"
            >
              <img
                src={icon.src}
                alt={icon.alt}
                width={'30px'}
                height={'30px'}
              />
            </IconButton>
          ))}
        </Box> */}
      </Box>
    </Box>
  );
};

export default FooterSection;
